@let isMobile = deviceService.isMobile$ | async;

<p-dialog
  (visibleChange)="$event ? null : close()"
  [header]="'users.form.header-create' | translate"
  [modal]="true"
  [visible]="opened"
  class="dialog-primary dialog-content-flex f-d-col {{ isMobile ? '' : 'w430' }}"
  [styleClass]="isMobile ? 'full-screen-mode' : ''"
>
  <app-user-form
    [data]="user"
    [mode]="mode"
    [country]="country"
    [forceRole]="forceRole"
    [usernamePrefix]="usernamePrefix"
    (cancelForm)="close()"
    (submitForm)="createUser($event)"
  ></app-user-form>
</p-dialog>
